/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Missing_PriceInputs */

const en_issue_missing_price = /** @type {(inputs: Issue_Missing_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`price missing`)
};

/**
* | output |
* | --- |
* | "price missing" |
*
* @param {Issue_Missing_PriceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_missing_price = /** @type {((inputs?: Issue_Missing_PriceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Missing_PriceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_missing_price(inputs)
});